<div class="modal-content">
  <div class="modal-header">
    <h6 class="modal-title">{{ 'AVALIACAO_ACESSO_REMOTO_TITULO' | translate }}</h6>
  </div>
  <div class="modal-body" [formGroup]="avaliacaoForm">
    <div class="row">
      <div class="col-12 text-center">
        <label>{{ 'AVALIACAO_ACESSO_REMOTO_SUBTITULO' | translate }}<span class="text-danger"> *</span></label>
        <div class="rating">
          <input id="avaliacao-remota-star1" name="avaliacao-remota-star" type="radio" value="1" class="radio-btn hide" (click)="setAvaliacaoValue(5)" />
          <label for="avaliacao-remota-star1">☆</label>
          <input id="avaliacao-remota-star2" name="avaliacao-remota-star" type="radio" value="2" class="radio-btn hide" (click)="setAvaliacaoValue(4)" />
          <label for="avaliacao-remota-star2">☆</label>
          <input id="avaliacao-remota-star3" name="avaliacao-remota-star" type="radio" value="3" class="radio-btn hide" (click)="setAvaliacaoValue(3)" />
          <label for="avaliacao-remota-star3">☆</label>
          <input id="avaliacao-remota-star4" name="avaliacao-remota-star" type="radio" value="4" class="radio-btn hide" (click)="setAvaliacaoValue(2)" />
          <label for="avaliacao-remota-star4">☆</label>
          <input id="avaliacao-remota-star5" name="avaliacao-remota-star" type="radio" value="5" class="radio-btn hide" (click)="setAvaliacaoValue(1)" />
          <label for="avaliacao-remota-star5">☆</label>
          <div class="clear"></div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <label>{{ 'AVALIACAO_ACESSO_REMOTO_OPCAO_LABEL' | translate }}<span class="text-danger"> *</span></label>
        <select class="form-control" formControlName="opcao">
          <option value="" disabled>{{ 'SELECIONE' | translate }}...</option>
          <option *ngFor="let opcao of opcoesAvaliacao" [value]="opcao">{{ opcao | translate }}</option>
        </select>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <label>{{ 'AVALIACAO_ACESSO_REMOTO_DETALHES_LABEL' | translate }}<span class="text-danger"> *</span></label>
        <ckeditor
          class="no-expanded"
          [editor]="Editor"
          [config]="editorConfig"
          formControlName="comentario"
        >
        </ckeditor>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success badge-pill" [disabled]="isSubmitDisabled()" (click)="avaliar()">
      {{ 'AVALIAR' | translate }}
    </button>
  </div>
</div>
